<template>
	<div class="goods">
	   <van-nav-bar
		:title="title"
		left-text=""
		left-arrow
		/>
		<div class="content">
		<p>注：支付凭证 <span>* ( 只能上传jpg/png文件，且不超过500kb )</span></p>
		<van-uploader
		  v-model="fileList"
		  multiple
		  :max-count="1"
		  :after-read="afterRead"
		/>
	</div>
</div>
</template>

<script type="text/javascript">
import vHead from "../../../components/Subhead.vue";	

import { mapState } from "vuex";
import { Uploader,Toast,NavBar} from "vant";
import {
	underLineSubmit
} from "@/api/dictionary";
export default {
	props: {
     item: {
      type: Object,
      default: () => {}
    },
	orderId:{
		type:String,
		default:''
	},
	memberId:{
		type:String,
		default:''
	}
  },
  data() {
    return {
      fileList: [],
		commentImg:[],
		title:"支付凭证"
    }
  },
    components: {
    vHead,
    [Uploader.name]: Uploader,
    [Toast.name]: Toast,
    [NavBar.name]: NavBar,
  },
    methods: {
		a(){
			this.$emit("a");
		},
		afterRead(item){
			let params = new FormData();
			params.append("file", item.file);
			params.append("memberId",this.memberId);
			params.append("orderId",this.orderId);
		
			// params.append("memberCategory",this.userInfo.memberCategory);
			underLineSubmit(params).then(res => {
				if (res.success) {
					this.titleFileId = res.result.id;
					Toast("上传成功");
					this.a();
				} else {
					Toast("上传失败");
				}
			});
		},
		obj() {
			var obj = {
				orderId: this.$route.params.id
			};

			if (this.userInfo && this.from == "member") {
				obj.memberId = this.userInfo.id;
				obj.memberCategory = this.userInfo.memberCategory;
			}

			return obj;
		}
  },
computed:{
	id() {
      return this.$route.query && this.$route.query.meetingId;
    },
	...mapState(["userInfo"])
}
};
</script>

<style type="text/css" lang="less" scoped>
/deep/.van-nav-bar .van-icon{
  color: #fff;
}
.content{ 
    padding:20px;
  p{ 
  	font-size: 14px; color: #000; margin:10px 0; margin-bottom: 20px;
   span{ color: #d64a4a; font-size: 12px; }
  }
}
</style>